module.exports = __webpack_public_path__ + "static/img/azpz.7a5df6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/azpz.png
// module id = jKm0
// module chunks = 1